import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from "react-router-dom";
import Swal from 'sweetalert2';
// import EntSetupSidebar from '../ent_setup_mainsidebar/EntSetupSidebar';
import MasterDashboardLayout from '../../../dashboard/MasterDashboardLayout';
import '../../../img_url';

function EditOurRecentWebProjects() {
    const navigate = useNavigate();
    const [ourRecentWeb, setOurRecentWeb] = useState({
        heading_name: "",
        web_link: "",
    });

    const [image, setImage] = useState('');
    const [picture, setPicture] = useState('');


    const { id } = useParams();
    // console.log('id checkibg',id)
    useEffect(() => {
        axios.get(`/edit-our-web-dev-project/${id}`).then(res => {
            console.log("edit-our-web-dev-project", res.data);
            if (res.data.status == 200) {
                setOurRecentWeb(res.data.heading);
                setOurRecentWeb({
                    heading_name: res.data.ourRecentWeb.heading_name,
                    web_link: res.data.ourRecentWeb.web_link,

                })
                setImage(res.data.ourRecentWeb.image)
                // console.log('image chek',res.data.ourRecentWeb.image)
            }
        })

    }, [])

    const onChangePicture = e => {
        console.log('picture: ', picture);
        setPicture(URL.createObjectURL(e.target.files[0]));
        setImage(e.target.files[0]);
    };

    const handleInput = (e) => {
        setOurRecentWeb({
            ...ourRecentWeb, [e.target.name]: e.target.value
        });
    }


    const updateHeading = (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append('heading_name', ourRecentWeb.heading_name);
        formData.append('web_link', ourRecentWeb.web_link);
        formData.append('image', image);

        if (image == '') {
            Swal.fire("Please fill up all inputs", '', 'error')

        }
        else if (image.size > 524288) {
            Swal.fire("Image size must be less than 0.5 mb", '', 'error')

        }

        else {
            axios.post(`/update-our-web-dev-project/${id}`, formData).then(res => {
                if (res.data.status == 200) {
                    Swal.fire(res.data.message, '', 'success')


                    setImage('');
                    setPicture('');
                    document.getElementById('heading_image').value = "";
                }
                navigate('/our-web-dev-project');
            })
        }
    }

    return (
        <>
            <MasterDashboardLayout>
                <div className="container-fluid">
                    <div className="row">
                        {/* <div className="col-md-3">
                            <EntSetupSidebar/>
                        </div> */}
                        <div className="col-md-12 mt-3">
                            <div className="card">
                                <div className="card-header">
                                    <h6 className="card-title"> Edit  Our Recent Web project
                                        <Link to={'/our-web-dev-project'} className="btn btn-primary btn-sm float-end"> Back </Link>
                                    </h6>
                                </div>
                                <div className="card-body">
                                    <form id="EarCanalForm" onSubmit={updateHeading} >
                                        <div className="card-body">

                                            <div className="col-md-12">


                                                <div className="form-group">
                                                    <label htmlFor="history_name" className="col-form-label-sm">Our Recent Web Project Name</label>
                                                    <input id="history_name" type="text" value={ourRecentWeb.heading_name} className="form-control" name="heading_name" onChange={handleInput} />
                                                    {/* <span className="text-danger">{ourRecentWeb.error_list.heading_name}</span> */}
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="web_link" className="col-form-label-sm">Web Link </label>
                                                    <input id='web_link' type="text" value={ourRecentWeb.web_link} className="form-control" name="web_link" onChange={handleInput} />
                                                    {/* <span className="text-danger">{ourRecentWeb.error_list.web_link}</span> */}
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="history_name" className="col-form-label-sm"> Image </label>
                                                    <input type="file" className="form-control" name="image" onChange={onChangePicture} />
                                                    {/* <span className="text-danger">{ourRecentWeb.error_list.heading_name}</span> */}

                                                </div>

                                                {
                                                    picture == '' ? <div className="form-group" id="heading_image" style={{ width: '100px', height: '90px' }}>
                                                        <img className="playerProfilePic_home_tile" src={`${global.img_url}/images/our_recent_projects/${image}`} style={{ width: '100px', height: '90px' }}></img>
                                                    </div>
                                                        :
                                                        <div className="form-group" style={{ width: '100px', height: '90px' }}>
                                                            <img className="playerProfilePic_home_tile" src={picture} style={{ width: '100px', height: '90px' }}></img>
                                                        </div>
                                                }



                                                {
                                                    image.size > 524288 && <div className='text-danger mt-4'>Image Size Must be less than 0.5 Mb </div>
                                                }


                                                <div className="float-right">
                                                    <button type="submit" className="btn btn-sm btn-primary text-uppercase float-end mt-2"><i
                                                        className="fas fa-save"></i> Update
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </MasterDashboardLayout>
        </>
    )
}

export default EditOurRecentWebProjects
